<template>
  <div>
    <van-row>
      <van-col :span="12">
        <van-field
          v-model="selectBirthmonth"
          readonly
          label="月份"
          placeholder="请选择月份"
          @click="showMonthPicker = true"
        />
      </van-col>
      <van-col :span="12">
        <van-field
          v-model="selectBirthyear"
          readonly
          label="年份"
          placeholder="请选择年份"
          @click="showYearPicker = true"
        />
      </van-col>
    </van-row>
    <van-row class="mt10" :gutter="10">
      <van-col :span="12">
        <ul class="date-list">
          <li>月度</li>
          <li v-for="(item,index) in monthList" :key="index" @click="checkMonthRecordDetail(item.createDate)">
            {{item.createDate}}
          </li>
        </ul>
      </van-col>
      <van-col :span="12">
        <ul class="date-list">
          <li>年度</li>
          <li v-for="(item,index) in yearList" :key="index" @click="checkYearRecordDetail(item.createDate)">
            {{item.createDate}}
          </li>
        </ul>
      </van-col>
    </van-row>
    <van-row :gutter="10" class="mt10">
      <van-col :span="12">
        <van-button size="small" type="primary" block @click="findmonth">查询</van-button>
      </van-col>
      <van-col :span="12">
        <van-button size="small" type="info" block>提交</van-button>
      </van-col>
    </van-row>
    <!--月份-->
    <van-popup v-model="showMonthPicker" position="bottom">
      <van-datetime-picker
        type="month-day"
        title="选择月"
      />
    </van-popup>
    <van-popup v-model="showYearPicker" position="bottom">
      <van-datetime-picker
        type="year"
        title="选择年"
      />
    </van-popup>
  </div>
</template>

<script>
  import {getTaxProvisionRecordApi} from '@/api/tax'

  export default {
    name: "Taxation",
    data() {
      return {
        showMonthPicker: false,
        showYearPicker: false,
        selectBirthyear: '',
        selectBirthmonth: '',
        monthList: [],
        yearList: []
      }
    },
    mounted() {
      this.monthRecord()
      this.yearRecord()
    },
    methods: {
      checkMonthRecordDetail(data) {
        this.$router.push({
          path: '/tax/month-detail',
          query: {
            d: data
          }
        })
      },
      async monthRecord() {
        const params = {
          C_GUID: this.getCookie("CompanyInfo").companyId,
          reportDate: '',
          type: 'month'
        }
        let response = await getTaxProvisionRecordApi(params);
        this.monthList = response.result
      },
      async yearRecord() {
        const params = {
          C_GUID: this.getCookie("CompanyInfo").companyId,
          reportDate: '',
          type: 'year'
        }
        let response = await getTaxProvisionRecordApi(params);
        this.yearList = response.result
      },
      findmonth() {
        this.$axios({
          method: 'post',
          url: '/fmsapi/TaxProvisionRecord/GetTaxReportList',
          data: this.$qs.stringify({
            C_GUID: sessionStorage.getItem('companyId'),
            reportDate: (this.selectBirthmonth).replace(/-/g, "/").replace(/-/g, "/"),
            type: 'month'
          })
        }).then(res => {
          this.monthList = res.data.result;
          this.selectBirthmonth = '';
        })
      },
      checkYearRecordDetail(date) {
        this.$router.push({
          path: '/tax/year-detail',
          query: {
            d: date
          }
        })
      }
    }
  }
</script>

<style lang="less" scoped>
  .date-list {
    background: white;
    padding: 0;
    margin: 0;

    li {
      text-align: center;
      height: 3rem;
      line-height: 3rem;
    }
  }
</style>
